var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-autocomplete',{attrs:{"value":_vm.value,"items":_vm.filteredCostCenters,"item-text":"labelWithLinkedInfo","item-value":"label","label":_vm.label,"rules":_vm.rules,"required":"","free-form-create":"","disabled":_vm.disabled},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }